import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { createSlice } from "@reduxjs/toolkit";
import { endPoint } from "constants/server/api";
var initialState = {
    data: null,
    isFetching: false,
    isError: false
};
var getAllBranchByPositionSlice = createSlice({
    name: "getAllBranchByPosition",
    initialState: initialState,
    reducers: {
        fetchData: function(state) {
            state.isFetching = true;
            state.data = null;
            state.isError = false;
        },
        fetchDataSuccess: function(state, action) {
            return _object_spread_props(_object_spread({}, state), {
                isFetching: false,
                data: action.payload
            });
        },
        fetchDataFailure: function(state) {
            return _object_spread_props(_object_spread({}, state), {
                isFetching: false,
                isError: true
            });
        },
        resetState: function() {
            return initialState;
        }
    }
});
var _getAllBranchByPositionSlice_actions = getAllBranchByPositionSlice.actions;
export var fetchData = _getAllBranchByPositionSlice_actions.fetchData, fetchDataSuccess = _getAllBranchByPositionSlice_actions.fetchDataSuccess, fetchDataFailure = _getAllBranchByPositionSlice_actions.fetchDataFailure, resetState = _getAllBranchByPositionSlice_actions.resetState;
export default getAllBranchByPositionSlice.reducer;
